import { AsyncLocalStorage } from 'node:async_hooks';
/**
 * Instance of AsyncLocalStorage for usage with LoggerMetadata.
 */
export const asyncLocalStorage = new AsyncLocalStorage();
//# sourceMappingURL=asyncLocalStorage.js.map